module.exports = __webpack_public_path__ + "static/img/theme1.d87efa67.jpg";